export enum QueryByType {
    DATE = "date",
    MONTH = "month",
    FILTER = "filter"
}